export default "__VITE_ASSET__BdDe_ghH__"